// import LayoutComponent from "../../components/layout"
import Image from 'next/image';
import Link from "next/link";
import environment from "../../utils/environment";
import { useEffect, useState } from "react";
import moment from "moment";
import { getNewCategoryV2, getNewPagesV2 } from "../../pages/api/blogs";
import HeadComponent from "../layout/Head";
import { useRouter } from "next/router";
import { IBreadcrumbList, IImageObject, INewsArticle, IWebPage } from '../gSnippet/interface';
import { generateGSnippet } from '../gSnippet';
import { usePathname } from "next/navigation";
import { chkUrl } from "../../utils/utils";
import dynamic from 'next/dynamic';
const DynamicLayoutComponent = dynamic(() => import('../../components/layout'));

const Blogs = ({seo}:any) => {
    const router = useRouter();
    const [origin, setOrigin] = useState("");
    const [data, setData]: any = useState(null);
    const [newData, setNewData]: any = useState(null);
    // const New = ({ item }: any) => {
    //     const [newItems, setNewItems] = useState(item.news);
    //     const [isShow, setIsShow] = useState(false);
    //     function showAll() {
    //         setNewItems(item.news);
    //         setIsShow(true)
    //     }

    //     return <div key={item.id} className="posts m-auto mt-12 lg:m-12 ">
    //         <div className="line"></div>
    //         <span className="new-blog-title">{item?.name ?? ""}</span>
    //         {/* DESKTOP */}
    //         <div className="hidden lg:block">
    //             {newItems.length > 1 ? <div className="list-posts gap-6">
    //                 {isShow === false &&
    //                     newItems.slice(0, 3)?.map((x: any) => {
    //                         return (
    //                             <Link
    //                                 //href={chkUrl(item.url)} 
    //                                 href={{ pathname: '/[...group]', query: { group: x?.url.split("/").filter((e: any) => e !== '') } }}
    //                                 key={x?.id} className="one-post">
    //                                 <div className="image-post relative">
    //                                     <Image
    //                                         className="w-full"
    //                                         src={x?.image_url ? environment.baseImageUrl + x?.image_url : "/asset/image/new-blog.png"}
    //                                         alt={x?.alt}
    //                                         title={x?.alt}
    //                                         layout='fill'
    //                                         objectFit='cover'
    //                                     />
    //                                 </div>
    //                                 <div className="flex flex-col gap-4 mt-4">
    //                                     <div className="flex gap-4">
    //                                         <Image
    //                                             src={"/asset/icon/ico_calender.svg"}
    //                                             alt={"calendar"}
    //                                             width={24}
    //                                             height={24}
    //                                         />
    //                                         <span>{x?.created_date ? moment(x?.created_date).format("DD/MM") : ""}</span>
    //                                     </div>

    //                                     <p className="content">{x?.name}</p>
    //                                 </div>
    //                             </Link>
    //                         )
    //                     })
    //                 }
    //                 {
    //                     isShow === true &&
    //                     newItems?.map((x: any) => {
    //                         return (
    //                             <Link
    //                                 //href={chkUrl(item.url)} 
    //                                 href={{ pathname: '/[...group]', query: { group: x?.url.split("/").filter((e: any) => e !== '') } }}
    //                                 key={x?.id} className="one-post">
    //                                 <div className="image-post relative">
    //                                     <Image
    //                                         className="w-full"
    //                                         src={x?.image_url ? environment.baseImageUrl + x?.image_url : "/asset/image/new-blog.png"}
    //                                         alt={x?.alt}
    //                                         layout='fill'
    //                                         objectFit='cover'
    //                                     />
    //                                 </div>
    //                                 <div className="flex flex-col gap-4 mt-4">
    //                                     <div className="flex gap-4">
    //                                         <Image
    //                                             src={"/asset/icon/ico_calender.svg"}
    //                                             alt={"calendar"}
    //                                             width={24}
    //                                             height={24}
    //                                         />
    //                                         <span>{x?.created_date ? moment(x?.created_date).format("DD/MM") : ""}</span>
    //                                     </div>

    //                                     <p className="content">{x?.name}</p>
    //                                 </div>
    //                             </Link>
    //                         )
    //                     })
    //                 }

    //             </div> : newItems.length === 1 && <Link
    //                 //href={newItems[0]?.url ?? ""} 
    //                 href={{ pathname: '/[...group]', query: { group: newItems[0]?.url.split("/").filter((e: any) => e !== '') } }}
    //                 className="new-blog mx-4">
    //                 <div className="wrap-posts ">
    //                     <div className="new-blog-image">
    //                         <Image
    //                             className="w-full"
    //                             src={newItems[0]?.image_url ? environment.baseImageUrl + newItems[0]?.image_url : "/asset/image/new-blog.png"}
    //                             alt={"blog banner"}
    //                             layout='fill'
    //                             objectFit='cover'
    //                         />
    //                     </div>
    //                     <div className="title-posts">
    //                         <p className="title">{newItems[0]?.name ?? ""}</p>
    //                         <div className="flex gap-4">
    //                             <Image
    //                                 src={"/asset/icon/ico_calender.svg"}
    //                                 alt={"Ngày viết"}
    //                                 width={24}
    //                                 height={24}
    //                             />
    //                             <span className="date-create">{newItems[0]?.created_date ? moment(newItems[0]?.created_date).format("DD/MM") : ""}</span>
    //                         </div>
    //                     </div>

    //                 </div>
    //             </Link>}
    //         </div>

    //         {/* MOBILE */}
    //         <div className="block lg:hidden">
    //             <Slider {...settings}>
    //                 {
    //                     newItems?.map((x: any) => {
    //                         return (
    //                             <Link
    //                                 //href={chkUrl(item.url)} 
    //                                 href={{ pathname: '/[...group]', query: { group: x?.url.split("/").filter((e: any) => e !== '') } }}
    //                                 key={x?.id}
    //                                 className="one-post px-2">
    //                                 <div className="image-post relative">
    //                                     <Image
    //                                         src={x?.image_url ? environment.baseImageUrl + x?.image_url : "/asset/image/new-blog.png"}
    //                                         alt={x?.alt}
    //                                         title={x?.alt}
    //                                         layout='fill'
    //                                         objectFit='cover'
    //                                     />
    //                                 </div>
    //                                 <div className="flex flex-col gap-4 mt-4">
    //                                     <div className="flex gap-4">
    //                                         <Image
    //                                             src={"/asset/icon/ico_calender.svg"}
    //                                             alt={"calendar"}
    //                                             width={24}
    //                                             height={24}
    //                                         />
    //                                         <span>{x?.created_date ? moment(x?.created_date).format("DD/MM") : ""}</span>
    //                                     </div>

    //                                     <p className="content">{x?.name}</p>
    //                                 </div>
    //                             </Link>
    //                         )
    //                     })
    //                 }
    //             </Slider>
    //         </div>
    //         {item.news?.length > 3 && isShow === false && <div className="flex w-full mt-12">
    //             <button onClick={showAll} className="blog_btn">Xem tất cả</button>
    //         </div>}
    //     </div>
    // }
    const [isLoading, setIsLoading] = useState(true);
    const [gSnippet, setGSnippet] = useState(null);
    const router_path = usePathname();
    // const { seo } = useContext(AppContext);
    
    const gSnippetLoad = async () => {
        try{
            let now = moment().toISOString();
            let webPage:IWebPage = {
                name: seo.title,
                description: seo.description,
                dateCreated: "",
                dateModified: "",
                primaryImageOfPage: "",
                keyword: seo.keyword
            }
            let imageObject:IImageObject = {};
            let newsArticle:INewsArticle = {};
            let _breadcrumb:Array<IBreadcrumbList> = [
                {
                    name: "Tin tức",
                    url: "/blog-tin-tuc"
                },
                
                
            ];
            if(seo.url !== "/blog-tin-tuc"){
                _breadcrumb.push({
                    name: seo.title,
                    url: seo.url
                })
            }
            let image_url = ""; //environment.baseImageUrl + arr_article[0].image_url;
        
            webPage.primaryImageOfPage = image_url;
            webPage.dateCreated = now;
            webPage.dateModified = now;
        
            imageObject = {
                // url_img: image_url,
                // caption: arr_article[0].name,
            }

            newsArticle = {
                headline: seo.title,
                arr_image: [],//arr_article.map((x:any) => x.image_url),
                description: seo.description,
                dateCreated: now,
                dateModified: now,
            }
            
            let gSnippet = await generateGSnippet(router_path, webPage, imageObject, _breadcrumb, newsArticle);
            setGSnippet(gSnippet);
        }catch(e){
            console.log(e);
        }
    }
    const GroupChildNew = ({ item }: any) => {
        const [newItems, setNewItems] = useState<any>({
            page: 1,
            limit: 16,
            totalElements: 0,
            news: []
        });
        const [isShow, setIsShow] = useState(true);

        function showAll() {
            let total = newItems.limit + newItems.limit;
            getNewCategoryV2(`page_id=${item.id}&page=${newItems.page}&limit=${total}`).then((res: any) => {
                setNewItems({
                    totalElements: res.totalElements,
                    page: 1,
                    limit: total,
                    news: res?.results ?? []
                })
            })
            setIsShow(true)
        }

        useEffect(() => {
            setIsLoading(true);
            getNewCategoryV2(`page_id=${item.id}&page=${newItems.page}&limit=${newItems.limit}`).then((res: any) => {
                setNewItems({
                    ...newItems,
                    totalElements: res.totalElements,
                    news: res.results ?? []
                })
            });
            setIsLoading(false);
        }, [])

        return newItems.totalElements > 0 ? <div key={item.id} className="posts m-auto lg:m-12 ">
            {item?.name && <div className="line"></div>}
            {item?.name && <span className="new-blog-title">{item?.name ?? ""}</span>}
            {/* DESKTOP */}
            <div className="hidden lg:block">
                {newItems?.news.length > 1 ? <div className="list-posts gap-6">
                    {isShow === false &&
                        newItems?.news.slice(0, 3)?.map((x: any) => {
                            return (
                                <Link
                                    href={chkUrl(x.url)} 
                                    // href={{ pathname: '/[...group]', query: { group: x?.url.split("/").filter((e: any) => e !== '') } }}
                                    key={x?.id} className="one-post">
                                    <div className="image-post relative">
                                        <Image
                                            className="w-full"
                                            src={x?.image_url ? environment.baseImageUrl + x?.image_url : "/asset/image/new-blog.png"}
                                            alt={x?.alt}
                                            title={x?.alt}
                                            layout='fill'
                                            objectFit='cover'
                                        />
                                    </div>
                                    <div className="flex flex-col gap-4 mt-4">
                                        <div className="flex gap-4">
                                            <Image
                                                src={"/asset/icon/ico_calender.svg"}
                                                alt={"calendar"}
                                                width={24}
                                                height={24}
                                            />
                                            <span>{x?.created_date ? moment(x?.created_date).format("DD/MM") : ""}</span>
                                        </div>

                                        <p className="content">{x?.name}</p>
                                    </div>
                                </Link>
                            )
                        })
                    }
                    {
                        isShow === true &&
                        newItems?.news?.map((x: any) => {
                            return (
                                <Link
                                    href={chkUrl(x.url)} 
                                    // href={{ pathname: '/[...group]', query: { group: x?.url.split("/").filter((e: any) => e !== '') } }}
                                    key={x?.id} className="one-post">
                                    <div className="image-post relative">
                                        <Image
                                            className="w-full"
                                            src={x?.image_url ? environment.baseImageUrl + x?.image_url : "/asset/image/new-blog.png"}
                                            alt={x?.alt}
                                            layout='fill'
                                            objectFit='cover'
                                        />
                                    </div>
                                    <div className="flex flex-col gap-4 mt-4">
                                        <div className="flex gap-4">
                                            <Image
                                                src={"/asset/icon/ico_calender.svg"}
                                                alt={"calendar"}
                                                width={24}
                                                height={24}
                                            />
                                            <span>{x?.created_date ? moment(x?.created_date).format("DD/MM") : ""}</span>
                                        </div>

                                        <p className="content">{x?.name}</p>
                                    </div>
                                </Link>
                            )
                        })
                    }

                </div> : newItems?.news.length === 1 && <Link
                    href={chkUrl(newItems?.news[0]?.url)} 
                    // href={{ pathname: '/[...group]', query: { group: newItems?.news[0]?.url.split("/").filter((e: any) => e !== '') } }}
                    className="new-blog mx-4">
                    <div className="wrap-posts ">
                        <div className="new-blog-image">
                            <Image
                                className="w-full"
                                src={newItems?.news[0]?.image_url ? environment.baseImageUrl + newItems?.news[0]?.image_url : "/asset/image/new-blog.png"}
                                alt={"blog banner"}
                                layout='fill'
                                objectFit='cover'
                            />
                        </div>
                        <div className="title-posts">
                            <p className="title">{newItems?.news[0]?.name ?? ""}</p>
                            <div className="flex gap-4">
                                <Image
                                    src={"/asset/icon/ico_calender.svg"}
                                    alt={"Ngày viết"}
                                    width={24}
                                    height={24}
                                />
                                <span className="date-create">{newItems?.news[0]?.created_date ? moment(newItems?.news[0]?.created_date).format("DD/MM") : ""}</span>
                            </div>
                        </div>

                    </div>
                </Link>}
            </div>

            {/* MOBILE */}
            <div className="block lg:hidden">
                {/* <Slider {...settings}> */}
                    {
                        newItems?.news.length > 0 ? newItems?.news?.map((x: any) => {
                            return (
                                <Link
                                    href={chkUrl(x.url)} 
                                    // href={{ pathname: '/[...group]', query: { group: x?.url.split("/").filter((e: any) => e !== '') } }}
                                    key={x?.id}
                                    className="one-post px-2">
                                    <div className="image-post relative">
                                        <Image
                                            src={x?.image_url ? environment.baseImageUrl + x?.image_url : "/asset/image/new-blog.png"}
                                            alt={x?.alt}
                                            title={x?.alt}
                                            layout='fill'
                                            objectFit='cover'
                                        />
                                    </div>
                                    <div className="flex flex-col gap-2 mt-4">
                                        <div className="flex gap-4">
                                            <Image
                                                src={"/asset/icon/ico_calender.svg"}
                                                alt={"calendar"}
                                                width={24}
                                                height={24}
                                            />
                                            <span>{x?.created_date ? moment(x?.created_date).format("DD/MM") : ""}</span>
                                        </div>

                                        <p className="content">{x?.name}</p>
                                    </div>
                                </Link>
                            )
                        }) : 
                        <p>Không có tin tức</p>
                    }
                {/* </Slider> */}
            </div>
            {newItems?.totalElements > newItems?.limit && <div className="flex w-full mt-2">
                <button onClick={showAll} className="blog_btn">Xem thêm</button>
            </div>}
        </div> : <></>
    }

    const GroupNew = ({ data }: any) => {

        return <div className="flex flex-col w-full">
            <Link
                href={chkUrl(data?.news[0]?.url)}
                // href={{ pathname: '/[...group]', query: { group: data?.news[0]?.url.split("/").filter((e: any) => e !== '') } }}
                className="new-blog mx-4">
                <span className="new-blog-title">{data?.name ?? ""}</span>
                <div className="wrap-posts ">
                    <div className="new-blog-image">
                        <Image
                            className="w-full"
                            src={data?.news[0]?.image_url ? environment.baseImageUrl + data?.news[0]?.image_url : "/asset/image/new-blog.png"}
                            alt={data?.news[0]?.alt}
                            title={data?.news[0]?.title}
                            layout='fill'
                            objectFit='cover'
                        />
                    </div>
                    <div className="title-posts">
                        <p className="title">{data?.news[0]?.name ?? ""}</p>
                        <div className="flex gap-4">
                            <Image
                                src={"/asset/icon/ico_calender.svg"}
                                alt={"Ngày viết"}
                                width={24}
                                height={24}
                            />
                            <span className="date-create">{data?.news[0]?.created_date ? moment(data?.news[0]?.created_date).format("DD/MM") : ""}</span>
                        </div>
                    </div>
                </div>
            </Link>
        </div>
    }

    useEffect(() => {
        if (router.asPath) {
            getNewPagesV2(router.asPath).then((res: any) => {
                setNewData(res)
            })
        }
        setIsLoading(false);
        // setOrigin(window?.location?.origin);
    }, [seo]);
    useEffect(() => {
        if (seo) {
            gSnippetLoad()
        }
    }, [seo]);

    // useEffect(() => {
    //     if (newData && newData?.has_news === true) {
    //         getNewCategoryV2(`page_id=${newData.id}&page=${1}&limit=${3}`)
    //     }
    // }, [newData])

    return (
        <>
            {/* <Head>
            <title>Tin tức</title>
            <meta name="description" content="Generated by create next app" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <link rel="icon" href="/favicon.ico" />
            <link rel="canonical" href={origin} />
        </Head> */}
            <HeadComponent gSnippet={gSnippet} seo={seo}/>
            <DynamicLayoutComponent className='' isLoading={isLoading}>
                <div className="banner-blog">
                    <div className="banner-backgroud">
                        <Image
                            className="w-full"
                            src={"/asset/image/blog-banner.png"}
                            alt={"blog banner"}
                            title={"blog banner"}
                            layout='fill'
                            objectFit='cover'
                        />
                    </div>
                    <div className="banner-content relative flex flex-col gap-6 justify-center px-4">
                        <Image
                            className="w-[205px] h-[72px] flex mx-auto"
                            src={"/asset/image/why_not.svg"}
                            alt={"why not"}
                            width={205}
                            height={72}
                        />
                        <div className="flex justify-center">
                            <p className="last-title">Hoài Giang shop nhận may, bán và cho thuê các loại trang phục. Chất lượng đi đầu nhưng giá cả cũng rất phải chăng. Ngoài ra chúng tôi cũng có may sẵn nhiều loại trang phục để phục vụ nhu cầu thuê hoặc mua liền của quý khách hàng.</p>
                        </div>
                    </div>
                </div>
                {/* {data && <Link
                    //href={data[0]?.news[0]?.url ?? ""} 
                    href={{ pathname: '/[...group]', query: { group: data[0]?.news[0]?.url.split("/").filter((e: any) => e !== '') } }}
                    className="new-blog mx-4">
                    <span className="new-blog-title">{data[0]?.name ?? ""}</span>
                    <div className="wrap-posts ">
                        <div className="new-blog-image">
                            <Image
                                className="w-full"
                                src={data[0]?.news[0]?.image_url ? environment.baseImageUrl + data[0]?.news[0]?.image_url : "/asset/image/new-blog.png"}
                                alt={data[0]?.news[0]?.alt}
                                title={data[0]?.news[0]?.title}
                                layout='fill'
                                objectFit='cover'
                            />
                        </div>
                        <div className="title-posts">
                            <p className="title">{data[0]?.news[0]?.name ?? ""}</p>
                            <div className="flex gap-4">
                                <Image
                                    src={"/asset/icon/ico_calender.svg"}
                                    alt={"Ngày viết"}
                                    width={24}
                                    height={24}
                                />
                                <span className="date-create">{data[0]?.news[0]?.created_date ? moment(data[0]?.news[0]?.created_date).format("DD/MM") : ""}</span>
                            </div>
                        </div>
                    </div>
                </Link>} */}
                {
                    newData?.default && newData?.default.length > 0 && <GroupNew data={newData.default[0]} />
                }
                {
                    newData?.has_news && <GroupChildNew item={newData} />
                }
                {
                    newData?.sub && newData?.sub.length > 0 && newData?.sub?.map((item: any) => {
                        return <GroupChildNew key={item.id} item={item}/>
                    })
                }
                {/* {
                    data?.slice(1, data.length)?.filter((item: any) => item.news?.length > 0).map((item: any) => {
                        return <New key={item.id} item={item} />
                    })
                } */}

            </DynamicLayoutComponent>
        </>)
}

// Blogs.getInitialProps = async (ctx: any) => {
//     let data = await getNews();
//     return { data: data }
// }

export default Blogs